<template>
	<ul>
        <perview-file v-if="isFilePriview" :type="lessonChat" v-bind:file="filePriviewData" @closePopup="closePopup" ></perview-file>
        <li v-if="staticChatData==false && listData && listData.length<1">
            <div class="chat-body other">
                <div class="picture">
                    <img alt="" class="avatar" src="/images/admin_profile.png">
                </div>
                <div class="text">
                    <span class="t-body3">
                        Hi {{userName}}, welcome!
                    </span>
                </div>
            </div>
        </li>
        <li v-for="(chat, index) in listData" :key="index">
            <div v-if="index === 0 || (index > 0 && ($moment(chat.created).format('YYMMDD') != $moment(listData[index-1].created).format('YYMMDD')))"
                class="datetime mgt-24"
            >
                <span class="t-helper">
                    {{$moment(chat.created).format('LL')}}
                    <!-- {{$moment(chat.created).format('dddd MMMM DD, YYYY')}} -->
                </span>
            </div>
            
            <!-- 이미지 -->
            <div v-for="(attachment, index2) in chat.attachments" :key="index2" :class="{
                    'me': chat.owner,
                    'other': !chat.owner,
                    'with-avatar': index === 0 && !chat.owner,
                    'with-avatar': index > 0 && listData[index-1].writer.id !== chat.writer.id && !chat.owner,
                    'first': index > 0 && listData[index-1].writer.id !== chat.writer.id,
                }"
                class="chat-body"
            >
                <div v-if="!chat.owner" class="picture" @click="handleChatModal(chat, index)">
                    <!-- admin profile -->
                    <img v-if="chatPermission(chat, index)" :src="'/images/admin_profile.png'" alt="" class="avatar"/>

                    <UserDetailActionModal 
                        v-if="modalOpen && index === selectedChild"
                        :type="'CHAT'" 
                        :data="chat" 
                        :selectedChild="selectedChild"
                        @block="handleUserBlock"
                        className="opacity-1 chat-modal question-chat"
                    />
                </div>
                <div v-if="!chat.isBlocked">
                    <img :class="{
                        'chat-attachment-left': chat.owner,
                        'chat-attachment-right': !chat.owner,
                        }" :src="attachment.resourceUri" alt="" tabindex="0" @click="fileDisply(attachment)" @keypress="fileDisply(attachment)">
                </div>
                <div class="text chat-name" v-else>
                    <span class="t-body6 font-r l-spacing45 t-line-h-20 chat-name">{{ $t("3814") }}</span>
                </div>
                <span class="t-helper pdl-8 pdr-8">
                    {{$moment(chat.created).format('LT')}}
                </span>
            </div>

            <div v-if="chat.msg"
                :class="{
                    'me': chat.owner,
                    'other': !chat.owner,
                    'with-avatar': index === 0 && !chat.owner,
                    'with-avatar': index > 0 && listData[index-1].writer.id !== chat.writer.id && !chat.owner,
                    'first': index > 0 && listData[index-1].writer.id !== chat.writer.id,
                }"
                class="chat-body"
            >
                <div v-if="!chat.owner" class="picture" @click="handleChatModal(chat, index)">
                    <!-- other profile -->
                    <UserImgProfile v-if="chatPermission(chat, index)" :data="chat.writer" />

                    <UserDetailActionModal 
                        v-if="modalOpen && index === selectedChild"
                        :type="'CHAT'" 
                        :data="chat" 
                        :selectedChild="selectedChild"
                        @block="handleUserBlock"
                        className="opacity-1 chat-modal question-chat"
                    />
                </div>
                
                <div v-if="chatPermission(chat, index)">
					<div class="mgl-5 t-body3" v-if="chat.write && chat.write.name">
						{{ $t("3437", { first: chat.writer.name.first, last: chat.writer.name.last }) }}
					</div>
					<div class="text chat-name">
						<span class="t-body6 font-r l-spacing45 t-line-h-20 chat-name">{{ chat.isBlocked ? $t("3814") : chat.msg ? chat.msg : 'No Message'}}</span>
					</div>
				</div>

				<div v-else class="text">
					<span class="t-body6 font-r l-spacing45 t-line-h-20">{{ chat.isBlocked ? $t("3814") : chat.msg ? chat.msg : 'No Message'}}</span>
				</div>
                <span class="t-helper  pdl-8 pdr-8">
                    {{$moment(chat.created).format('LT')}}
                    <!-- {{$moment(chat.created).format('LLLL')}} -->
                </span>
            </div>
        </li>
        <div v-if="modalOpen" class="modal-background" @click="closeModal" />
    </ul>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 채팅 리스트 컴포넌트(my learn / exam question - chatting list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import PerviewFile from "@/components/board/PerviewFile";
import UserDetailActionModal from "@/components/common/modal/UserDetailActionModal.vue";
import { userMixin } from "@/mixins/user";

export default {
    props: ['listData'],
    mixins: [userMixin],
    data() {
		return {
            isFilePriview:false,
            lessonChat:'lessonChat',
            staticChatData: true,
            userName:'',
            selectedChild: null,
            modalOpen: false,
        }
    },
    components: {
        PerviewFile,
        UserDetailActionModal,
        UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
    },

    mounted() {
        this.userName = localStorage.getItem("memberName");
		if(this.listData && this.listData.listData>0) {
			this.staticChatData =  true
		} else {
			setTimeout(() => {
				this.staticChatData =  false
			}, 2000);
			
		}
	},
    methods: {
      fileDisply(data) {
        this.isFilePriview = true;
        this.filePriviewData = data;
        },
      closePopup() {
        this.isFilePriview = false;
        },
      handleModal(chat, idx) {
        this.modalOpen = !this.modalOpen;
        this.selectedChild = idx;
      },
      closeModal() {
        this.modalOpen = false;
        this.selectedChild = null;
      },
      async handleUserBlock(item, isBlocked) {
        await this.blockUser(item, isBlocked);
        window.location.reload();
      },
      chatPermission(chat, index) {
        return (index === 0 && !chat.owner) || (index > 0 && this.listData[index-1].writer.id !== chat.writer.id && !chat.owner);
      },
      handleChatModal(chat, index) {
        if (this.chatPermission(chat, index)) {
            this.handleModal(chat, inbox);
        }
      }
    }
}
</script>

<style scoped>
.chat-modal {
  z-index: 2 !important;
  top: auto !important;
  left: 10px !important;
  margin-top: -20px;
  margin-left: 20px;
  max-width: 40%;
}
</style>
